import React from "react";
import logo from "../../assest/LOGO-01.webp";
import "./footer.scss";
import { footerData, NavData } from "../../data/MainData";
import SocialMedia from "../SocialMedia";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="footer-bg">
        <div className="stars"></div>
        <div className="stars2"></div>
        <div className="stars3"></div>
      <div className="footer-inner">
        <div className="footer-logo">
          <Link to="/">
            <img
              src={logo}
              className="f-logo"
              alt="Abilasha wickramarathna-home"
            />
          </Link>
          <div>
            <span className="wording">{footerData.wording1}</span>
          </div>
          <div>
            <SocialMedia />
          </div>

          <div className="sep-line"></div>

          <div>
            <ul className="navbar-list">
              {NavData.map((item, index) => {
                return (
                  <li className="navbar-item" key={item.id}>
                    <Link to={item.url} className="navbar-link hover-underline">
                      <span className="span">{item.heading}</span>
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>

          <div className="copyright">
            {footerData.copyright}
          </div>

        </div>
      </div>
    </div>
  );
};

export default Footer;
